export default __webpack_public_path__ + "static/iPad-Left-87ad77171cdf91dabc2b82023ab16653.jpg";